export enum BlockchainCode {
  BITCOIN = 'BITCOIN',
  LITECOIN = 'LITECOIN',
  ETHEREUM = 'ETHEREUM',
  SOLANA = 'SOLANA',
  TRON = 'TRON',
  BSC = 'BSC',
}
